// ================================================================================================
// React components
import * as React from 'react';
// internal library
import _ from 'lodash';
import './ColorPaletteSelector.less'
import { paletteList } from './ColorPaletteSelectorData';
import { IComponentSizeProp } from './Interfaces';
import { isDefined, isStringEmpty } from '@Utils/Micro';
import { SearchBar } from './SearchBar';
// ================================================================================================
let _searchBarSource: { key: string, value: string }[] = null;
function getSearchBarSource(): { key: string, value: string }[] {
    if (!isDefined(_searchBarSource)) {
        _searchBarSource = _.map(paletteList, (icon, key) => {
            return { key: key.toString(), value: icon };
        })
    }
    return _searchBarSource;
}
// ------------------------------------------------------------------------------------------------
export interface ColorPaletteSelectorProps extends IComponentSizeProp {
    style?: React.CSSProperties;
    defaultColor: string;
    onColorSelection?: (colorClassName: string) => void;
}
// ------------------------------------------------------------------------------------------------
export interface ColorPaletteSelectorState {
    selectedColor?: string;
    filteredColorList: string[];
}
// ------------------------------------------------------------------------------------------------
export class ColorPaletteSelector extends React.Component<ColorPaletteSelectorProps, ColorPaletteSelectorState> {
    public static defaultProps: ColorPaletteSelectorProps = {
        height: 400,
        width: 1024,
        defaultColor: 'red'
    };
    // --------------------------------------------------------------------------------------------
    constructor(props: ColorPaletteSelectorProps) {
        super(props);

        this.state = {
            selectedColor: this.props.defaultColor,
            filteredColorList: paletteList
        };
    }
    // --------------------------------------------------------------------------------------------
    private onColorSelect = (event: React.MouseEvent<{}>) => {
        let selectedColor = (event.target as HTMLElement).className;
        this.setState({ selectedColor: selectedColor });

        if (isDefined(this.props.onColorSelection))
            this.props.onColorSelection(selectedColor);
    }
    // --------------------------------------------------------------------------------------------
    public render() {
        const { width, height, onColorSelection } = this.props;
        const { selectedColor, filteredColorList } = this.state;

        let colPixel = 70;
        let col = Math.floor(width / colPixel);
        const columnGap = 5;
        let itemSize = Math.floor((width - columnGap * col) / col);
        const selectedClass = isDefined(selectedColor)
            ? selectedColor : '';

        const paddingTop = 20
        const searchBarHeight = 48;
        const selectedColorHeight = 40;

        return <div
            className='colorpalette-selector'
            style={{
                width: width,
                height: height,
                paddingTop: paddingTop,
            }}>

            {/* Search bar */}
            <SearchBar
                simple={true}
                style={{
                    height: searchBarHeight,
                    maxWidth: width / 2,
                    margin: '0 auto',
                }}
                iconButtonStyle={{
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0,
                    marginBottom: 0
                }}
                source={getSearchBarSource()}
                onSearch={(keys, emptySearchValue) => {
                    if (emptySearchValue) {
                        this.setState({ filteredColorList: paletteList });
                    } else {
                        this.setState({
                            filteredColorList: _.map(keys, (key) => {
                                return paletteList[key];
                            })
                        });
                    }
                }}
            />

            {/* Toolbar with select color class name */}
            <div
                key='root-div'
                style={{
                    height: selectedColorHeight,
                    width: width / 2,
                    margin: '0 auto',
                    paddingTop: 14
                }}
            >
                <span
                    key='selected-color'
                    style={{
                        color: "#9E9E9E",
                        fontSize: 16
                    }}
                >
                    {'Selected color :   '}
                </span>
                <div
                    key='color'
                    className={selectedClass}
                    style={{
                        width: 20,
                        height: 20,
                        display: 'inline-block',
                        marginLeft: 4
                    }}
                />
                <span
                    key='selected-color-text'
                    style={{
                        color: "#9E9E9E",
                        fontSize: 14,
                        paddingLeft: 10
                    }}
                >
                    {'  ' + selectedClass}
                </span>
                {!isStringEmpty(selectedClass)
                    ?
                    <div
                        key='clear-icon'
                        className="fas fa-times"
                        style={{
                            float: 'right',
                            cursor: 'pointer',
                            color: "#9E9E9E"
                        }}
                        onClick={() => {
                            this.setState({ selectedColor: null })
                            if (isDefined(onColorSelection))
                                onColorSelection('');
                        }}
                    />
                    :
                    null}
            </div>

            {/* Filtered color list*/}
            <div
                key='main-div'
                style={{
                    width: width,
                    height: height - paddingTop - selectedColorHeight - searchBarHeight,
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    paddingBottom: 1
                }}
            >
                <div
                    key={'row-grid'}
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill,minmax(' + itemSize + 'px, 1fr))',
                        width: width,
                        clear: 'both',
                        gridRowGap: columnGap,
                        gridColumnGap: columnGap
                    }}
                >
                    {_.map(filteredColorList, (item, index) => {
                        return <div
                            key={index}
                            className={item + (item == selectedColor ? ' cell-selected' : '')}
                            style={{
                                width: itemSize,
                                height: itemSize,
                                lineHeight: itemSize + 'px',
                                textAlign: 'center',
                                cursor: 'pointer'
                            }}
                            onClick={this.onColorSelect}
                        />;
                    })}
                </div>
            </div>
        </div>
    }
    // --------------------------------------------------------------------------------------------
}
// ================================================================================================
